import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "reward-box" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "overlay-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.received != 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "box-img dimmed",
            src: _ctx.boxImg,
            alt: ""
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "box-img",
            src: _ctx.boxImg2,
            alt: ""
          }, null, 8, _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          style: _normalizeStyle({
                    color: _ctx.received == 1 ? '#e670c8' : '#86718c',
                     fontWeight: _ctx.received == 1 ? '600' : '100'
                })
        }, _toDisplayString(_ctx.peopleCount) + " " + _toDisplayString(_ctx.$t('common.pepole')), 5),
        _createElementVNode("div", {
          class: "rewardNum",
          style: _normalizeStyle({
                    padding: '5px 0',
                    color: _ctx.received == 1 ? 'gold' : '#ffffffa6',
                    fontSize: '13px',
                    fontWeight: _ctx.received == 1 ? '600' : '100'
                })
        }, _toDisplayString(Number(_ctx.reward)), 5)
      ])
    ])
  ]))
}